<template lang="pug">
  .loader(:class='{active: isLoading}') {{ $t('loading') }} {{ loadingProgress }}
</template>

<script>
export default {
  computed: {
    isLoading () { return this.$store.getters.loading },
    loadingProgress () {
      const progress = this.$store.getters.loadingProgress
      if (progress > 0) { return `${Math.round(progress * 100)}%` }
      return ''
    }
  },
  i18n: {
    messages: {
      en: { loading: 'Loading...' },
      fr: { loading: 'Chargement...' }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/scss/abstract/variables.scss';

  .loader {
    position: fixed;
    left: 0; right: 0; top: 0; bottom: 0;
    z-index: 999;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    color: rgba(0,0,0, .5);

    background: rgba(255, 255, 255, .9);
    transition: opacity 250ms;
    opacity: 0;
    pointer-events: none;

    &.active {
      opacity: 1;
      pointer-events: all;
    }

    &:before {
      content: '';
      position: relative;
      display: block;
      margin-bottom: 2em;
      font-size: 1em;
      width: 5em;
      height: 5em;
      border-radius: 50%;
      border: .25em solid rgba($blue, .1);
      border-top: .25em solid $blue;
      animation: loadAnimation 750ms infinite linear;
    }
  }

  @keyframes loadAnimation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
